export interface TableOptionType {
    class?: string;
    style?: string;
    height?: string;
    ['max-height']?: string;
    largeHeight?: string;
    largeMaxHeight?: string;
    oneRowLargeHeight?: string;
    oneRowLargeMaxHeight?: string;
    ['row-key']?: string;
    border: boolean;
    resizable: boolean;
    stripe: boolean;
}

export const DefaultOption: TableOptionType = {
    class: 'table',
    style: 'width:  100%',
    height: 'calc(100vh - 380px)',
    ['max-height']: 'calc(100vh - 380px)',
    largeHeight: 'calc(100vh - 267px)',
    largeMaxHeight: 'calc(100vh - 267px)',
    oneRowLargeHeight: 'calc(100vh - 337px)',
    oneRowLargeMaxHeight: 'calc(100vh - 337px)',
    ['row-key']: 'id',
    border: true,
    resizable: true,
    stripe: true,
};
